import store from '@/store'

let validatePasswords = (str) => {
  const result = store.getters['config/keys/IS_EQUAL']
  return result
}

export default validatePasswords
